module.exports = __webpack_public_path__ + "static/imagen_01-d6d33ab0146bcf5fa16c610d9cb1c11c.jpg";